import { IProduct, IProductVariant } from '@common/interface/product'
import { getImagesOfProduct } from './util/product'
import { canBuy } from './util/can-buy'

export const getStructuredProduct = ({ product }: { product: IProduct }) => {
  const { id, title, description, variants, collections } = product

  const variantsLength = variants.length

  return {
    '@context': 'https://schema.org/',
    '@type': 'ProductGroup',
    name: title,
    description,
    brand: {
      '@type': 'Brand',
      name: collections?.[0]?.brands?.[0]?.title || 'Habbit'
    },
    productGroupID: id,
    image: getImagesOfProduct(product)?.map((item) => item.url) || [],
    hasVariant: variants.map((variant) => {
      const sortedVariantPricesByCurrency =
        variant?.prices?.sort((prev, next) => {
          if (prev.currency_code < next.currency_code) {
            return -1
          }

          if (prev.currency_code > next.currency_code) {
            return 1
          }

          return 0
        }) || []

      return {
        '@type': 'Product',
        sku: variant.sku,
        image: (variant as IProductVariant)?.image,
        // We show combine of title and variant in case product has more than 1 variant
        name: variantsLength > 1 ? `${title} - ${variant.title}` : title,
        offers: {
          '@type': 'Offer',
          availability: canBuy(variant)
            ? 'https://schema.org/InStock'
            : 'https://schema.org/OutOfStock',
          // If a price list is a draft, its prices won't be applied even if its conditions are met
          // So, we need to filter the draft prices
          priceSpecification:
            sortedVariantPricesByCurrency
              .filter(
                (item) =>
                  !item.price_list || item.price_list.status === 'active'
              )
              .map((item) => {
                const { price_list } = item

                return {
                  '@type': 'UnitPriceSpecification',
                  priceType: price_list
                    ? 'https://schema.org/SalePrice'
                    : 'https://schema.org/ListPrice',
                  priceCurrency: item.currency_code.toUpperCase(),
                  price: item.amount / 100,
                  validFrom: price_list?.starts_at,
                  validThrough: price_list?.ends_at
                }
              }) || []
        }
      }
    })
  }
}
